/**
 * Derives the partner API base URL from the current browser environment,
 * using the same hostname-based logic as the web-app's getApiEnvironment().
 *
 * Three environments:
 *   staging   → https://partner.staging.mangovoice.net
 *   prod-uk   → https://partner.uk.mangovoice.net
 *   prod-us   → https://partner.us.mangovoice.net
 */
/**
 * Matches `<app>-staging.mangovoice.com` hosts (e.g. `app-staging`,
 * `admin3-staging`). New staff apps deploying under the same naming
 * convention route to staging Partner Ops automatically without
 * touching this function.
 */
const STAGING_HOST_PATTERN = /^[a-z0-9-]+-staging\.mangovoice\.com$/

const isStagingHost = (host: string): boolean => {
  if (STAGING_HOST_PATTERN.test(host)) return true
  // Per-PR preview deploys live under `*.app-preview.mangovoice.com`
  const parts = host.split('.')
  return (
    parts.length === 4 &&
    parts.slice(1).join('.') === 'app-preview.mangovoice.com'
  )
}

export const getPartnerBaseUrl = (): string => {
  if (import.meta.env.VITE_PARTNER_BASE_URL) {
    return import.meta.env.VITE_PARTNER_BASE_URL as string
  }

  const { hostname, host } = window.location

  if (hostname.endsWith('.co.uk')) {
    return 'https://partner.uk.mangovoice.net'
  }

  if (isStagingHost(host)) {
    return 'https://partner.staging.mangovoice.net'
  }

  if (host.startsWith('localhost')) {
    return 'https://partner.staging.mangovoice.net'
  }

  return 'https://partner.us.mangovoice.net'
}
